module.exports = __webpack_public_path__ + "static/media/meter_4.48857c6d.png";